module.exports = __webpack_public_path__ + "img/ai-background.89c8410d.jpg";